import axios from 'axios';

export const setDefaultAuthorizationHeader = (accessToken: string): void => {
	axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
};

export const setDefaultCompanyIdHeader = (companyId: number | null): void => {
	axios.defaults.headers.common['CompanyId'] = companyId;
};
